import type { ListItemAvatarProps } from '@mui/material';
import MuIListItemAvatar from '@mui/material/ListItemAvatar';
import { forwardRef } from 'react';

const ListItemAvatar = forwardRef<HTMLDivElement, ListItemAvatarProps>(
  (props, ref) => {
    return <MuIListItemAvatar ref={ref} {...props} />;
  },
);
export default ListItemAvatar;
